/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

module.exports = function (checkoutList) {
    if (window.jQuery) {
        /*eslint no-undef: "off"*/
        window.jQuery.fn.checkoutList = function (inputConfig) {
            checkoutList(this.attr('id'), inputConfig);
            return this;
        };
    }
};
